module.exports = __webpack_public_path__ + "img/ai-icon.e94a676c.svg";